module.exports = __webpack_public_path__ + "static/media/013.2b5226ce.jpg";